import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export const BundleDetails = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" data-id="element-26">
      <div className="mx-auto max-w-6xl" data-id="element-27">
        <div className="mb-12 text-center" data-id="element-28">
          <h2 className="font-serif text-3xl font-bold text-terracotta md:text-4xl" data-id="element-29">
            TU PAQUETE COMPLETO INCLUYE LAS 4 GUÍAS:
          </h2>
          <p className="mt-2 text-xl font-medium text-text-dark" data-id="element-30">
            (Invierno, Primavera, Verano y Otoño)
          </p>
        </div>

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-31">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-32">
            <img src="https://cdn.magicpatterns.com/uploads/oyQU3ukgbnQqF4vp3do7BJ/1.png" alt="Las 4 Guías de Temporada" className="w-full rounded-2xl shadow-xl" data-id="element-33" />
          </motion.div>

          {/* List */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-34">
            <ul className="space-y-6" data-id="element-35">
              <li className="flex items-start space-x-4" data-id="element-36">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-37">
                  <Check className="h-4 w-4" data-id="element-38" />
                </div>
                <span className="text-lg text-text-dark" data-id="element-39">
                  <strong data-id="element-40">Guía Paso a Paso:</strong> ¡Hazlo todo en 4 horas.
                  Usamos 10 recetas para crear 20 comidas!
                </span>
              </li>
              <li className="flex items-start space-x-4" data-id="element-41">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-42">
                  <Check className="h-4 w-4" data-id="element-43" />
                </div>
                <span className="text-lg text-text-dark" data-id="element-44">
                  <strong data-id="element-45">Instrucciones de Cocción:</strong> Optimizadas para
                  Olla Instantánea, Olla de Cocción Lenta u Horno.
                </span>
              </li>
              <li className="flex items-start space-x-4" data-id="element-46">
                <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage text-white" data-id="element-47">
                  <Check className="h-4 w-4" data-id="element-48" />
                </div>
                <div className="text-lg text-text-dark" data-id="element-49">
                  <strong data-id="element-50">Recetas Extensamente Probadas:</strong>
                  <ul className="mt-3 space-y-2 pl-2 text-base text-text-dark/80" data-id="element-51">
                    <li className="flex items-center space-x-2" data-id="element-52">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-53"></span>
                      <span data-id="element-54">Lomo de Cerdo al Romero con Ajo y Papas</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-55">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-56"></span>
                      <span data-id="element-57">Lasaña de Pollo Blanca "Sin Esfuerzo"</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-58">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-59"></span>
                      <span data-id="element-60">Sopa Cremosa de Brócoli con Cheddar</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-61">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-62"></span>
                      <span data-id="element-63">Pollo General Tso con Verduras Crujientes</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-64">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-65"></span>
                      <span data-id="element-66">Pasta Gratinada con Carne y Queso</span>
                    </li>
                    <li className="flex items-center space-x-2" data-id="element-67">
                      <span className="h-1.5 w-1.5 rounded-full bg-terracotta" data-id="element-68"></span>
                      <span data-id="element-69">Estofado de Carne Campestre</span>
                    </li>
                    <li className="flex items-center space-x-2 font-medium italic text-terracotta" data-id="element-70">
                      <span data-id="element-71">(¡Y docenas más para cada temporada del año!)</span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};